import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import myLibraryActions from '../../../../redux/actions/my_library_actions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import Modalizer from 'components/modalizer/modalizer'
import { localize } from 'helpers/translator'
import sessionTypes from 'helpers/enums/sessionTypes'
import LessonCodesLaunchSession from '../../my_library_launch_session.jsx'
import myLibraryLiveSessionMultipleCodesSelector from 'redux/selectors/my_library/my_library_live_session_multiple_codes_selector'
import LiveSessionSvg from 'assets/images/ic_live_session.svg'

class LessonCodesLaunchLiveSessionModal extends PureComponent {

	constructor() {
		super()
		this.handleResumeAction = this.handleResumeAction.bind(this)
		this.handleLaunchNewSession = this.handleLaunchNewSession.bind(this)
		this.handleCancelAction = this.handleCancelAction.bind(this)
	}

	handleCancelAction() {
		this.props.actions.closeLiveSessionCodesModal()
	}

	handleResumeAction(currentCode) {
		this.props.actions.resumeActiveSession(
			this.props.presentation_uid,
			currentCode.session_uid,
			sessionTypes.LIVE_SESSION,
			this.props.hasZoom
		)
	}

	handleLaunchNewSession() {
		this.props.actions.launchNewSession(this.props.presentation_uid, this.props.hasZoom)
	}

	render() {
		return (
			<Modalizer width='558px' modalName={this.props.modalName} closeAction={this.handleCancelAction}>
				<LessonCodesLaunchSession
					actualTimestamp={this.props.actualTimestamp}
					icon={LiveSessionSvg}
					handleLaunchNew={this.handleLaunchNewSession}
					launchNewText={localize('my_library_launch_live_participation_new')}
					handleSelectedCode={this.handleResumeAction}
					handleCancelAction={this.handleCancelAction}
					canShare={false}
					buttonText={localize('my_library_launch_live_session_resume')}
					codes={this.props.codes}
					subtitle={localize('my_library_launch_session_subtitle')}
				/>
			</Modalizer>
		)
	}
}

LessonCodesLaunchLiveSessionModal.propTypes = {
	hasZoom: PropTypes.bool,
	actions: {
		launchNewSession: PropTypes.func.isRequired,
		resumeActiveSession: PropTypes.func.isRequired,
		closeLiveSessionCodesModal: PropTypes.func.isRequired,
	},
}

LessonCodesLaunchLiveSessionModal.defaultProps = {
	hasZoom: false,
}

function mapStateToProps(state) {
	return myLibraryLiveSessionMultipleCodesSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		resumeActiveSession: myLibraryActions.resumeActiveSession,
		launchNewSession: myLibraryActions.launchNewSession,
		closeLiveSessionCodesModal: myLibraryActions.closeLiveSessionCodesModal,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(LessonCodesLaunchLiveSessionModal)
